import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../../constants/fetchStatuses';
import { ReducerState } from '../../../store.types';

export const companyDepartmentsSelector = ({ companyDepartments }: ReducerState) => companyDepartments;

export const companyDepartmentsLoadingSelector = createSelector(
  companyDepartmentsSelector,
  ({ fetchCompanyDepartmentsStatus }) => fetchCompanyDepartmentsStatus === fetchStatuses.pending,
);

export const companyDepartmentCreateLoadingSelector = createSelector(
  companyDepartmentsSelector,
  ({ createCompanyDepartmentStatus }) => createCompanyDepartmentStatus === fetchStatuses.pending,
);

export const companyDepartmentLoadingSelector = createSelector(
  companyDepartmentsSelector,
  ({ fetchCompanyDepartmentStatus }) => fetchCompanyDepartmentStatus === fetchStatuses.pending,
);

export const companyDepartmentUpdateLoadingSelector = createSelector(
  companyDepartmentsSelector,
  ({ updateCompanyDepartmentStatus }) => updateCompanyDepartmentStatus === fetchStatuses.pending,
);

export const companyDepartmentDeleteLoadingSelector = createSelector(
  companyDepartmentsSelector,
  ({ deleteCompanyDepartmentStatus }) => deleteCompanyDepartmentStatus === fetchStatuses.pending,
);

export const companyDepartmentRestoreLoadingSelector = createSelector(
  companyDepartmentsSelector,
  ({ restoreCompanyDepartmentStatus }) => restoreCompanyDepartmentStatus === fetchStatuses.pending,
);
